module.exports = __webpack_public_path__ + "3d11375ad2bc86751a8fc23ba33267a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/vertex_pharmaceuticals_2022_chart.png
// module id = 1752
// module chunks = 0